import React from 'react';
import {Slider} from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery/useMediaQuery";

const TimeRangeSlider = (props) => {
	const isSmall = useMediaQuery('(max-width:600px)');

	const formatTime = (mins) => {
		let hours = Math.round(mins/60);
		const ampm = hours >= 12 ? 'p' : 'a';
		hours = hours % 12;
		hours = hours ? hours : 12;
		return hours + ampm;
	};

	const marks = [];
	for( let i=0; i<=1440; i+=isSmall ? 180 : 120 ) {
		marks.push({value: i, label: formatTime(i)});
	}

	return (
		<Slider value={props.value} onChange={props.onChange}
				valueLabelDisplay="auto"
				valueLabelFormat={formatTime}
				marks={marks}
				min={0} max={1440}
				step={60}
		/>
	);
};

export default TimeRangeSlider;